import React, { Component } from 'react';
import { Table, DatePicker, Button, Pagination } from 'antd';
import TableC from '../../basicElement/TableC';
import CRCWeeklyTable from './components/CRCWeeklyTable';
import ExportModal from './components/ExportModal';
import NextWeekPlan from './components/NextWeekPlan';
import SearchSelect from '../../common/SearchSelect';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import Sider from '../SumEffSider';
import moment from 'moment';

const DateFormat = 'YYYY-MM-DD';

class CRCWeekly extends Component {
    state = {
        loading: false,
        searchParams: {
            startDate: moment().subtract(moment().day() - 1,'days'),
            endDate: moment().add( 7- moment().day() ,'days'),
        },
        dataList: [],
        siteTotal: [],
        pagination: {
            current: 1,
        },
        siteOptions: [],
        userOptions: [],
        investigationSiteId: '',
        investigationSiteCode: '',
        investigationSiteName: '',
        finishDate: '',
    };

    //中心
    siteSelectChanged = value => {   
        const { searchParams } = this.state;
        if (value) {
            searchParams.investigationSiteId = value.key;
        } else {
            searchParams.investigationSiteId = '';
        }
        this.setState({searchParams});
    }

    parseSiteData = (res, value) => {
        if ((res.data || res.datas) ) {
            const sourceData = res.data ? res.data.siteList.datas : res.datas;
            const data = sourceData.map(item => ({
                text: `${item.investigationSiteName}-(${item.investigationSiteCode})`,
                value: item.investigationSiteId,
            }));
            this.setState({ siteOptions: data });
        } else {
            this.setState({ siteOptions: [] });
        }
    };

    //角色
    userSelectChanged = value => {
        const { searchParams } = this.state;
        if (value) {
            searchParams.userId = value.key;
        } else {
            searchParams.userId = '';
        }
        this.setState({searchParams});
    }

    parseUserData = (res, value) => {
        if ((res.data || res.datas) ) {
            const sourceData = res.data ? res.data.crcList: res.datas;
            const data = sourceData.map(item => ({
                text: `${item.userCompellation}[${item.employeeCode}]`,
                value: item.userId,
            }));
            this.setState({ userOptions: data });
        } else {
            this.setState({ userOptions: [] });
        }
    };
    
    onStartChange = (data, dateString) => {
        const { searchParams = {} } = this.state;
        if ( data == null){
            searchParams.startDate = moment().subtract(moment().day() - 1,'days');
            searchParams.endDate = moment().add( 7- moment().day() ,'days');
            this.setState({
                searchParams
            })
            return;
        }
        let dTemp = moment(dateString),
            dTemp1 = moment(dateString);
        searchParams.startDate = dTemp.startOf('week');
        searchParams.endDate = dTemp1.endOf('week');
        this.setState({ searchParams });
    }

    disabledStartDate = (date) => {
        const { finishDate } = this.state;
        if (finishDate) {
            return date.valueOf() > moment(finishDate).endOf('week').valueOf();
        } else {
            return false;
        }
    }

    searchComponent = () => {
        const { siteOptions, userOptions, searchParams } = this.state;
        const  isCenter = sessionStorage.getItem('investigationSiteName') == '中心汇总';
        const { startDate, endDate } = searchParams;
        const element = (
            <div className="search-bar" style={{ marginBottom: 16 }}>
                <div className="search-item month-range-picker">
                    <label className="ui-label">工作日期</label>
                    <DatePicker
                        className="begin"
                        format={DateFormat}
                        value={startDate}
                        allowClear={true}
                        onChange={this.onStartChange}
                        disabledDate={this.disabledStartDate}
                    />
                    <DatePicker
                        className="end"
                        format={DateFormat}
                        value={endDate}
                        allowClear={true}
                        onChange={this.onStartChange}
                        disabledDate={this.disabledStartDate}
                    />
                </div>
                {
                    isCenter &&
                    <div className="search-item">
                        <label className="ui-label">中心</label>
                        <SearchSelect 
                            style={{width:200}}
                            url = {API_URL.site.list}
                            searchKey = 'searchKey'
                            sourceData={siteOptions}
                            parserData={this.parseSiteData}
                            watchValue={this.siteSelectChanged}
                            handleSelect = {this.siteSelectChanged}
                            placeholder={'输入中心或编号自动检索'}
                            allowClear={true}
                        />
                    </div>
                }
                {
                    isCenter &&
                    <div className="search-item">
                        <label className="ui-label">CRC</label>
                        <SearchSelect 
                            style={{width:160}}
                            url = {API_URL.team.userlist}
                            searchKey = 'keyword'
                            sourceData={ userOptions}
                            parserData={ this.parseUserData }
                            watchValue={this.userSelectChanged}
                            handleSelect = { this.userSelectChanged }
                            placeholder={'输入名字或工号自动检索'}
                            allowClear={true}
                        />
                    </div>
                }
                <div className="search-item">
                    <Button type="primary" onClick={this.search}>搜索</Button>
                    <Button type="primary" onClick={this.export}>导出</Button>
                </div>
            </div>
        );
        return element;
    };

    search = () => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({ pagination });
        this.loadData({ offset: 1 });
    };

    export = () => {
        const { userId = '', investigationSiteId = '', startDate, endDate } =  this.state.searchParams;
        const options = {
            userId,
            investigationSiteId,
            startDate: startDate.format(DateFormat),
            endDate: endDate.format(DateFormat),
        }
        this.ExportModalRef.show(options);
    }
    
    showNextWeekPlan = params => {
        const { searchParams } = this.state;
        params.startDate = searchParams.startDate.format(DateFormat);
        params.endDate = searchParams.endDate.format(DateFormat);
        this.planRef.show(params);
    }

    componentDidMount() {
        this.getInvEndDateByWeek();
    }

    getInvEndDateByWeek = () => {
        const { invId } = sessionStorage;
        const options = {
            method: 'POST',
            url: API_URL.contract.getInvEndDateByWeek,
            data: { investigationId: invId },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                const { searchParams } = this.state;
                const { endDate } = searchParams;
                if (data && endDate.valueOf() >= moment(data).valueOf()) {
                    searchParams.startDate = moment(data).subtract(moment(data).day() - 1, 'days');
                    searchParams.endDate = moment(data).add(7 - moment(data).day(), 'days');
                }
                this.setState({
                    finishDate: data,
                    searchParams,
                }, () => {
                    this.loadData({ offset: 1 }); 
                });
            },
        };
        $.sendRequest(options);
    }

    loadData = (params = {}) => {
        this.setState({ loading: true });
        const { searchParams, pagination, siteOptions, userOptions } = this.state;
        let { userId = '', investigationSiteId = '', startDate, endDate } = searchParams;
        if (investigationSiteId) {
            const falg = siteOptions.some(item => {
                return item.value == investigationSiteId;
            });
            if (!falg) {
                investigationSiteId = ''
            }
        }
        if (userId) {
            const falg = userOptions.some(item => {
                return item.value == userId;
            });
            if (!falg) {
                userId = ''
            }
        }
        const options = {
            url: `${API_URL.sumtotal.queryInvestigationCrcWeek}`,
            data: {
                userId,
                investigationSiteId,
                startDate: startDate && startDate.format(DateFormat),
                endDate: endDate && endDate.format(DateFormat),
                offset: pagination.current,
                ...params,
            },
            dataType: 'json',
            doneResult: res => {
                if (res.datas) {
                    const investigationSiteId = res.datas[0].investigationSiteId;
                    const investigationSiteCode = res.datas[0].investigationSiteCode;
                    const investigationSiteName = res.datas[0].investigationSiteName;
                    const dataList = res.datas[0].crcWeeklyList || [];
                    const siteTotal = dataList.length != 0 ? dataList[0].siteTotal.data.dataList : [];
                    pagination.total = res.totalCount;
                    this.setState({
                        loading: false,
                        dataList,
                        investigationSiteId,
                        investigationSiteCode,
                        investigationSiteName,
                        siteTotal,
                        pagination,
                        beginWeek: startDate,
                    });
                }
            },
            errorResult: () => {
                pagination.total = 1;
                this.setState({
                    loading: false,
                    dataList: [],
                    investigationSiteId: '',
                    investigationSiteCode: '',
                    investigationSiteName: '',
                    siteTotal: [],
                    pagination,
                    beginWeek: startDate,
                });
            },
        };
        $.sendRequest(options);
    }

    getColumns = () => {
        const { blindType } = sessionStorage;
        const isUnBlind = blindType === 'NOTBLIND';
        const columns = [{
            title: '中心',
            dataIndex: 'investigationSiteName',
            key: 'investigationSiteName',
            width: 110,
            fixed:'left',
            align: 'center',
        }, {
            title: '本周工时数',
            dataIndex: 'manHourString',
            key: 'manHourString',
        }, {
            title: '本周FTE数',
            dataIndex: 'fteString',
            key: 'fteString',
        }];
        if (!isUnBlind) {
            columns.push({
                title: '本周筛选数',
                dataIndex: 'amountFilter',
                key: 'amountFilter',
            }, {
                title: '本周知情数',
                dataIndex: 'amountInformed',
                key: 'amountInformed',
            }, {
                title: '本周随机(入组)数',
                dataIndex: 'amountRandom',
                key: 'amountRandom',
                width: 110,
            });
        }
        columns.push({
            title: '本周完成访视数',
            dataIndex: 'amountVisit',
            key: 'amountVisit',
            width: 110,
        }, {
            title: '本周退出数',
            dataIndex: 'amountDrop',
            key: 'amountDrop',
        }, {
            title: '本周方案违背数',
            dataIndex: 'amountViolation',
            key: 'amountViolation',
            width: 110,
        });
        if (!isUnBlind) {
            columns.push({
                title: '本周SAE数',
                dataIndex: 'amountSae',
                key: 'amountSae',
            });
        }
        return columns;
    }

    getDataSource = () => {
        const sites = [];
        let { siteTotal, investigationSiteName, investigationSiteCode } = this.state;
        investigationSiteName = investigationSiteCode ? investigationSiteName + '(' + investigationSiteCode + ')' : investigationSiteName;
        if (siteTotal.length != 0) {
            siteTotal.map(item => {
                sites.push({
                    ...item,
                    investigationSiteName,
                });
            });
        } else {
            if (investigationSiteName) {
                sites.push({ investigationSiteName });
            }
        }
        return sites;
    }

    onChange = page => {
        const { pagination } = this.state;
        pagination.current = page;
        this.setState({ pagination });
        this.loadData({ offset: page });
    }

    getCRCWeeklyTable = () => {
        const { loading, dataList, beginWeek, finishDate } = this.state;
        const options =  dataList.map(item => {
            return (
                <CRCWeeklyTable
                    key={item.siteUserName}
                    loading={loading}
                    userId={item.userId}
                    beginWeek={beginWeek}
                    finishDate={finishDate}
                    workTypes={item.workTypes}
                    siteUserName={item.siteUserName}
                    showNextWeekPlan={this.showNextWeekPlan}
                />
           )
        });
        return options;
    }

    render() { 
        const { loading, pagination } = this.state;
        const { curRole } = sessionStorage;
        const isCRC = curRole == 'CRC';
        const total = isCRC ? 1 : pagination.total;
        return (
            <div className="content">
                <Sider selectKey='crcWeekly'/>
                <div className="main crc-weekly">
                    { this.searchComponent() }
                    { this.getCRCWeeklyTable() }
                    <TableC
                        columns={this.getColumns()}
                        data={this.getDataSource()}
                        rowKey="investigationSiteName"
                        loading={loading}
                    />
                    <Pagination style={{float: 'right', marginTop: 40}} current={pagination.current} onChange={this.onChange} total={total} pageSize={1}/>
                </div>
                <NextWeekPlan ref={el => this.planRef = el} reload={this.loadData}/>
                <ExportModal ref={el => this.ExportModalRef = el} />
            </div>
        );
    }
}

export default CRCWeekly;


// WEBPACK FOOTER //
// ./src/components/sumTotal/crcWeekly/index.js